import { colors } from '../../../constants';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 900,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  button: {
    margin: theme.spacing.unit,
    backgroundColor: colors.parimary,
    width: '100px',
  },
  text: {
    color: '#ffffff',
    marginRight: '4px',
  },
  columnRow: {
    paddingRight: '16px',
  },
  colTable: {
    maxWidth: '180px',
  },
  filterRow: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    marginBottom: '8px',
  },
  searchWrapper: {
    minHeight: '60px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
    marginBottom: '16px',
    justifyContent: 'space-between',
  },
  exportButton: {
    minWidth: '120px',
    width: 'auto',
    whiteSpace: 'nowrap',
    backgroundColor: colors.dark,
  },
  statusSelect: {
    minWidth: 140,
  },
});

export default styles;
